'use client'

import PropTypes from 'prop-types'
import MUIStack from '@mui/material/Stack'
import MUITypography from '@mui/material/Typography'
import MUIIconButton from '@mui/material/IconButton'
import MUITooltip from '@mui/material/Tooltip'
import { InfoIcon } from '@repo/ui/InfoIcon'

export const FormSectionTitle = ({ title = 'Title goes here', tooltipText, endElement = null, sx = {} }) => {
  return (
    <MUIStack
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      sx={{ mt: 6, mb: 0, minHeight: '24px', ...sx }}
    >
      <MUIStack direction="row" alignItems="center">
        <MUITypography variant="body1" data-testid="FormSectionTitle" sx={{ textTransform: 'uppercase', mb: 0 }}>
          {title}
        </MUITypography>

        {tooltipText ? (
          <MUITooltip title={tooltipText || ''} placement="top" arrow>
            <MUIIconButton>
              <InfoIcon sx={{ width: '16px', height: '16px', color: '#3D517B8F' }} />
            </MUIIconButton>
          </MUITooltip>
        ) : null}
      </MUIStack>

      {endElement}
    </MUIStack>
  )
}

FormSectionTitle.propTypes = {
  title: PropTypes.string,
  tooltipText: PropTypes.string,
  endElement: PropTypes.node,
  sx: PropTypes.object
}
